import { City } from './city';
import { Country } from './country';
import { Customer } from './customer';
import { StatesProvinces } from './statesProvinces';

export interface ShipsTo {
  id: string;
  customerId: string;
  countryId: string;
  cityId: string;
  stateProvinceId: string;
  orderId: string;
  adddressType: number;
  code: string;
  name: string;
  contactName: string;
  address1: string;
  address2: string;
  postalCode: string;
  phone: string;
  fax: string;
  email: string;
  country: Country;
  customer: Customer;
  city: City;
  stateProvince: StatesProvinces;
}

export enum ShipsToAddressTypeEnum {
  Billing = 0,
  Shipping = 1,
}

export enum EShippingMode {
  Shipping = 'Ship',
  Pickup = 'Pick up in store',
  Arranged='Customer Arranged Shipping'
}
